module.exports = __webpack_public_path__ + "img/prev.a1887067.svg";